module.exports = __webpack_public_path__ + "img/icon-10.c7ca98f1.png";